import { render } from "./MenuForm.vue?vue&type=template&id=0cfcf897&scoped=true&ts=true"
import script from "./MenuForm.vue?vue&type=script&lang=ts"
export * from "./MenuForm.vue?vue&type=script&lang=ts"

import "./MenuForm.vue?vue&type=style&index=0&id=0cfcf897&scoped=true&lang=scss"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cfcf897"]])

export default __exports__